/// <reference path="custom-services-setup/api-key-view/api-key-view.component.ts" />
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {JwtInterceptor} from "./helpers/jwt.interceptor";
import {DateInterceptor} from "./helpers/date.interceptor";
import {SafePipe} from "./helpers/safe.pipe";
import {UnauthorizedContainerComponent} from './partials/unauthorized-container/unauthorized-container.component';
import {AuthorizedContainerComponent} from './partials/authorized-container/authorized-container.component';
import {LoginComponent} from './authentication/login/login.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TopbarComponent} from './partials/topbar/topbar.component';
import {HorizontalNavComponent} from './partials/horizontal-nav/horizontal-nav.component';
import {FooterComponent} from './partials/footer/footer.component';
import {RightSidebarComponent} from './partials/right-sidebar/right-sidebar.component';
import {NgSlimScrollModule, SLIMSCROLL_DEFAULTS} from "ngx-slimscroll";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { NgbRadio } from '@ng-bootstrap/ng-bootstrap/buttons/radio'
import {ChartjsModule} from "@ctrl/ngx-chartjs";
import {RolesManagementComponent} from './roles-management/roles-management.component';
import {DataTablesModule} from "angular-datatables";
import {NgxUiLoaderModule, NgxUiLoaderRouterModule} from "ngx-ui-loader";
import {ToastrModule} from "ngx-toastr";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {UserManagementComponent} from './user-management/user-management.component';
import {UserViewComponent} from './user-management/user-view/user-view.component';
import {RoleViewComponent} from './roles-management/role-view/role-view.component';
import {SettlementComponent} from './settlement/settlement.component';
import {DatePipe} from "@angular/common";
import {HoldDialogComponent} from './settlement/hold-dialog/hold-dialog.component';
import {ReleaseDialogComponent} from './settlement/release-dialog/release-dialog.component';
import {ParticipantManagementComponent} from './participant-management/participant-management.component';
import {ParticipantViewComponent} from './participant-management/participant-view/participant-view.component';
import {ClientManagementComponent} from './client-management/client-management.component';
import {ClientEditComponent} from './client-management/client-edit/client-edit.component';
import {ConfirmationDialogComponent} from './partials/confirmation-dialog/confirmation-dialog.component';
import {NgSelect2Module} from 'ng-select2';
import {AccountConfirmComponent} from './authentication/account-confirm/account-confirm.component';
import {TerminalManagementComponent} from "./terminal-management/terminal-management.component";
import {TerminalViewComponent} from "./terminal-management/terminal-view/terminal-view.component";
import {MerchantManagementComponent} from "./merchant-management/merchant-management.component";
import {MerchantViewComponent} from "./merchant-management/merchant-view/merchant-view.component";
import {TerminalConfigManagement} from "./terminal-config-management/terminal-config-management.component";
import {TerminalConfigView} from "./terminal-config-management/terminal-config-view/terminal-config-view.component";
import {CardAcceptorConfigManagementComponent} from './card-acceptor-config-management/card-acceptor-config-management.component';
import {CardAcceptorConfigViewComponent} from './card-acceptor-config-management/card-acceptor-config-view/card-acceptor-config-view.component';
import {ForgotPasswordComponent} from './authentication/forgot-password/forgot-password.component';
import {InfoDialogComponent} from "./settlement/info-dialog/info-dialog.component";
import { SinkNodeMappingViewComponent } from './sink-node-mapping-management/sink-node-mapping-view/sink-node-mapping-view.component';
import { SinkNodeMappingManagementComponent } from './sink-node-mapping-management/sink-node-mapping-management.component';
import { CardSetMappingViewComponent } from './card-set-mapping-view/card-set-mapping-view.component';
import { MerchantAuditComponent } from './merchant-audit/merchant-audit.component';
import { MerchantAuditViewComponent } from './merchant-audit/merchant-audit-view/merchant-audit-view.component';
import { TerminalAuditComponent } from './terminal-audit/terminal-audit.component';
import { TerminalAuditViewComponent } from './terminal-audit/terminal-audit-view/terminal-audit-view.component';
import { MerchantConfigAuditComponent } from './merchant-config-audit/merchant-config-audit.component/merchant-config-audit.component';
import { TerminalManagementConfigAuditComponent } from './terminal-config-audit/terminal-management-config-audit.component';
import { MerchantConfigAuditManagementComponent } from './merchant-config-audit/merchant-config-management-audit.component';
import { TerminalConfigAuditComponent } from './terminal-config-audit/terminal-config-audit/terminal-config-audit.component';
import { UserProfileComponent } from './authentication/user-profile/user-profile.component';
import {PasswordResetComponent} from "./authentication/user-profile/password-reset/password-reset.component";
import { SinkNodeMappingDialogComponent } from './sink-node-mapping-management/sink-node-mapping-view/sink-node-mapping-dialog/sink-node-mapping-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReportManagementComponent } from './report-management/report-management.component';
import { ReportMerchantViewComponent } from './report-management/report-merchant-view/report-merchant-view.component';
import { TutukaReportManagementComponent } from './report-management/tutuka-report-management/tutuka-report-management.component';
import { ReportUserManagementComponent } from './report-management/report-user-management/report-user-management.component';
import { UserAuditComponent } from './user-audit/user-audit.component';
import { ReportUserViewManagementComponent } from './report-management/report-user-management/report-user-view-management/report-user-view-management.component';
import {RoleAuditComponent} from "./role-audit/role-audit.component";
import { ReportClientParticipantLinkComponent } from './report-management/report-client-participant-link/report-client-participant-link.component';
import {ProductProfileMappingViewComponent} from "./product-profile-mapping-view/product-profile-mapping-view.component";
import {TerminalCapabilityMappingViewComponent} from "./terminal-capability-mapping-view/terminal-capability-mapping-view.component";
import {CommsProfileMappingViewComponent} from "./comms-profile-mapping-view/comms-profile-mapping-view.component";
import { CustomTagsViewComponent } from './custom-tags-view/custom-tags-view.component';
import { TerminalGroupCustomParameterComponent } from './terminal-config-management/terminal-config-view/terminal-group-custom-parameter/terminal-group-custom-parameter.component';
import { CreditComponent } from './credit/credit.component';
import { VasConfigurationViewComponent } from './vas-configuration/vas-configuration-view.component';
import { MerchantMigrationViewComponent } from './merchant-migration/merchant-migration-view.component';
import { CustomServicesSetupComponent } from './custom-services-setup/custom-services-setup/custom-services-setup.component';
import { ServiceEditComponent } from './custom-services-setup/service-edit/service-edit.component';
import { ServiceParameterEditComponent } from './custom-services-setup/service-parameter-edit/service-parameter-edit.component';
import { AuditMerchantDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-merchant-details/audit-merchant-details.component';
import { AuditContactDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-contact-details/audit-contact-details.component';
import { AuditCommissionDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-commission-details/audit-commission-details.component';
import { AuditVasDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-vas-details/audit-vas-details.component';
import { AuditSinkNodeMappedFieldsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-sink-node-mapped-fields/audit-sink-node-mapped-fields.component';
import { AuditStructuralDataDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-structural-data-details/audit-structural-data-details.component';
import { AuditPackedStructuralDataDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-packed-structural-data-details/audit-packed-structural-data-details.component';
import { AuditMerchantParamsDataDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-merchant-params-data-details/audit-merchant-params-data-details.component';
import { AuditBankDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-bank-details/audit-bank-details.component';
import { AuditVasCustomerDetailsComponent } from './merchant-audit/merchant-audit-view/audit-details/audit-vas-customer-details/audit-vas-customer-details.component';
import { ApiKeyComponent } from './custom-services-setup/api-key-view/api-key-view.component';
import { MerchantSignUpComponent } from './merchant-sign-up/sign-up/signup-base/signup-base.component';
import { AramexTrackingComponent } from './merchant-sign-up/aramex-tracking/aramex-tracking.component';
import { TerminalStagingComponent } from './merchant-sign-up/terminal-staging/terminal-staging.component';
import { MerchantTerminalsConfigurationComponent } from './merchant-sign-up/merchant-terminals-configuration/merchant-terminals-configuration.component';
import { TerminalCardViewComponent } from './merchant-sign-up/terminal-card-view/terminal-card-view.component';
import { MerchantTerminalStagingComponent } from './merchant-sign-up/merchant-terminal-staging/merchant-terminal-staging.component';
import { TerminalsConfigurationComponent } from './merchant-sign-up/terminals-configuration/terminals-configuration.component';
import { DispatchTerminalComponent } from './merchant-sign-up/dispatch-terminal/dispatch-terminal.component';
import { TerminalSignUpComponent } from './merchant-sign-up/terminal-sign-up/terminal-sign-up.component';
import { DeliveryNoteComponent } from './merchant-sign-up/delivery-note/delivery-note.component';
import { DeleteTicketComponent } from './merchant-sign-up/delete-ticket/delete-ticket.component';
import { ArchivedTerminalsCardComponent } from './merchant-sign-up/archived-terminals-card/archived-terminals-card.component';
import { SignupContactComponent } from './merchant-sign-up/sign-up/signup-contact/signup-contact.component';
import { SignupTerminalComponent } from './merchant-sign-up/sign-up/signup-terminal/signup-terminal.component';
import { SignupSummaryComponent } from './merchant-sign-up/sign-up/signup-view-summary/signup-summary.component';
import { SignupMerchantComponent } from './merchant-sign-up/sign-up/signup-merchant/signup-merchant.component';
import { TerminalSignupReportComponent } from './merchant-sign-up/terminal-signup-report/terminal-signup-report.component';
import { ReturnedTerminalsComponent } from './merchant-sign-up/returned-terminals/returned-terminals.component';
import { ESocketConfigComponent } from './terminal-config-management/terminal-config-view/e-socket-config/e-socket-config.component';

import { MerchantReportRegistrationComponent } from './report-management/merchant-report-registration/merchant-report-registration.component';
import { OtpComponent } from './authentication/otp/otp.component';
import {SafeHtmlPipe} from "./authentication/user-profile/safe-html.pipe";
import { ChartsModule } from 'ng2-charts';
import { DashboardComponent } from './dashboard/dashboard-base/dashboard-base.component';
import { DashboardDefaultComponent } from './dashboard/dashboard-default/dashboard-default.component';
import { MerchantGraphsComponent } from './dashboard/merchant-graphs/merchant-graphs.component';
import { MerchantViewBillingComponent } from './dashboard/merchant-view-billing/merchant-view-billing.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TransactionReportComponent } from './report-management/transaction-report/transaction-report-base/transaction-report-base.component';
import { RawTransactionReportComponent } from './report-management/transaction-report/raw-transaction-report/raw-transaction-report.component';
import { ReconciledTransactionReportComponent } from './report-management/transaction-report/reconciled-transaction-report/reconciled-transaction-report.component';
import { GiftCardTransactionReportComponent } from './report-management/transaction-report/giftcard-transaction-report/giftcard-transaction-report.component';
import { HeaderReportComponent } from './report-management/transaction-report/shared-report-header/header-report.component';
import { ExceptionCardReportComponent } from './report-management/transaction-report/exception-card-report/exception-card-report.component';

@NgModule({
  declarations: [
    AppComponent,
    SafePipe,
    SafeHtmlPipe,
    UnauthorizedContainerComponent,
    AuthorizedContainerComponent,
    LoginComponent,
    TopbarComponent,
    HorizontalNavComponent,
    FooterComponent,
    RightSidebarComponent,
    DashboardComponent,
    MerchantViewBillingComponent,
    DashboardDefaultComponent,
    MerchantGraphsComponent,
    RolesManagementComponent,
    UserManagementComponent,
    UserViewComponent,
    RoleViewComponent,
    SettlementComponent,
    HoldDialogComponent,
    ReleaseDialogComponent,
    ParticipantManagementComponent,
    ParticipantViewComponent,
    MerchantManagementComponent,
    MerchantViewComponent,
    TerminalManagementComponent,
    TerminalViewComponent,
    ClientManagementComponent,
    ClientEditComponent,
    ConfirmationDialogComponent,
    AccountConfirmComponent,
    TerminalConfigManagement,
    TerminalConfigView,
    CardAcceptorConfigManagementComponent,
    CardAcceptorConfigViewComponent,
    PasswordResetComponent,
    ForgotPasswordComponent,
    InfoDialogComponent,
    SinkNodeMappingViewComponent,
    SinkNodeMappingManagementComponent,
    CardSetMappingViewComponent,
    MerchantAuditComponent,
    MerchantAuditViewComponent,
    TerminalAuditComponent,
    TerminalAuditViewComponent,
    MerchantConfigAuditComponent,
    TerminalManagementConfigAuditComponent,
    MerchantConfigAuditManagementComponent,
    TerminalConfigAuditComponent,
    UserProfileComponent,
    SinkNodeMappingDialogComponent,
    ReportManagementComponent,
    ReportMerchantViewComponent,
    TutukaReportManagementComponent,
    ReportUserManagementComponent,
    TutukaReportManagementComponent,
    ReportUserViewManagementComponent,
    UserAuditComponent,
    RoleAuditComponent,
    ProductProfileMappingViewComponent,
    ReportClientParticipantLinkComponent,
    TerminalCapabilityMappingViewComponent,
    CommsProfileMappingViewComponent,
    CustomTagsViewComponent,
    TerminalGroupCustomParameterComponent,
    CreditComponent,
    VasConfigurationViewComponent,
    MerchantMigrationViewComponent,
    CustomServicesSetupComponent,
    ServiceEditComponent,
    ServiceParameterEditComponent,
    AuditBankDetailsComponent,
    AuditMerchantDetailsComponent,
    AuditContactDetailsComponent,
    AuditCommissionDetailsComponent,
    AuditVasDetailsComponent,
    AuditSinkNodeMappedFieldsComponent,
    AuditStructuralDataDetailsComponent,
    AuditPackedStructuralDataDetailsComponent,
    AuditMerchantParamsDataDetailsComponent,
    AuditVasCustomerDetailsComponent,
    ApiKeyComponent,
    MerchantSignUpComponent,
    AramexTrackingComponent,
    TerminalStagingComponent,
    MerchantTerminalsConfigurationComponent,
    TerminalCardViewComponent,
    MerchantTerminalStagingComponent,
    TerminalsConfigurationComponent,
    DispatchTerminalComponent,
    TerminalSignUpComponent,
    DeliveryNoteComponent,
    DeleteTicketComponent,
    ArchivedTerminalsCardComponent,
    SignupMerchantComponent,
    SignupContactComponent,
    SignupTerminalComponent,
    SignupSummaryComponent,
    TerminalSignupReportComponent,
    ReturnedTerminalsComponent,
    ESocketConfigComponent,

    MerchantReportRegistrationComponent,
    OtpComponent,
    TransactionReportComponent,
    RawTransactionReportComponent,
    ReconciledTransactionReportComponent,
    GiftCardTransactionReportComponent,
    HeaderReportComponent,
    ExceptionCardReportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgSlimScrollModule,
    ChartjsModule,
    DataTablesModule.forRoot(),
    NgxUiLoaderModule.forRoot({logoUrl: "assets/images/logo-light.png"}),
    NgxUiLoaderRouterModule.forRoot({showForeground: false}),
    BrowserAnimationsModule,
    NgbModule,
    NgSelect2Module,
    ChartsModule, // Import ChartsModule here
    NgMultiSelectDropDownModule,
    ToastrModule.forRoot()
  ],
  entryComponents: [],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true},
    {
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        alwaysVisible: false,
        height: 'auto',
        position: 'right',
        barOpacity: '0.2',
        gridOpacity: '0',
        barWidth: '6',
        gridBackground: '#9ea5ab',
      }
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
